import { defineStore } from "pinia"

export const useLocationStore = defineStore({
  id: "locations",
  state: () => ({
    locations: [],
    filteredData: [],
    isLoading: true,
    selectedLocation: {},
  }),
  getters: {
    getLocations: (state) => state.locations,
    getFilteredData: (state) => state.filteredData,
    getIsLoading: (state) => state.isLoading,
    getSelectedItem: (state) => state.selectedLocation,
  },
  actions: {
    updateFilteredData(value: never[]): void {
      this.filteredData = value
    },
  },
})
